import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import classnames from 'classnames';

import ControlButton from '../Shared/ControlButton';

class Snapshot extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			snapshotId: null,
			isLoading: false,
			error: false,
		};

		this.getSnapshot = this.getSnapshot.bind(this);
		this.renderSnapshotUrl = this.renderSnapshotUrl.bind(this);
		this.getClassNames = this.getClassNames.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		// If the pet or its goodies changed, reset the snapshot.
		if (!_.isEqual(this.props.activePet, nextProps.activePet) || !_.isEqual(this.props.activeGoodies, nextProps.activeGoodies)) {
			this.resetSnapshot();
		}
	}

	getClassNames() {
		return classnames('snapshot', {
			'snapshot--is-loading': this.state.isLoading,
			'snapshot--has-url': this.state.snapshotId,
		});
	}

	getSnapshot() {
		// If there's already a snapshot, don't get a new one.
		if (this.state.snapshotId) {
			return;
		}

		// Otherwise, set the loading state and call the fetch.
		this.setState({ isLoading: true }, this.saveCatToDatabase);
	}

	resetSnapshot() {
		this.setState({ snapshotId: null });
	}

	saveCatToDatabase() {
		// Put together the cat to save.
		const thisCat = {
			...this.props.activePet,
			...this.props.activeGoodies,
		};

		// TODO change this to the production URL
		fetch('https://tabbycats.club/save', {
			method: 'POST',
			mode: 'cors',
			cache: 'default',
			body: JSON.stringify(thisCat),
			headers: {
				'Content-Type': 'application/json',
				'Access-Control-Request-Method': 'post',
				'Access-Control-Allow-Credentials': 'true',
				'Access-Control-Allow-Origin': '*',
			}
		})
			.then(response => response.text())
			.then((text) => {
				// Save the snapshot ID and set loading to false.
				this.setState({
					snapshotId: text,
					error: false,
				});

				// This timeout lets the flash animation reach its apex
				setTimeout(() => {
					this.setState({ isLoading: false });
				}, 100);
			})
			.catch((err) => {
				this.setState({ error: true, isLoading: false });
				console.error('Snapshot error: ', err);
			});
	}

	renderSnapshotUrl() {
		// If there's no snapshotId, don't show a link.
		if (!this.state.snapshotId) {
			return null;
		}

		// TODO change this to the production server URL
		return (
			<a
				className="snapshot__url"
				href={`https://tabbycats.club/cat/${this.state.snapshotId}`}
				target="_blank"
				rel="noopener noreferrer">
				tabbycats.club/{this.state.snapshotId}
			</a>
		);
	}

	render() {
		// Show the snapshot URL or the "Snapshot!" cta
		const label = this.state.error
			? <span>Oops, it didn’t work.<br />Do you have internet?</span>
			: this.renderSnapshotUrl() || 'Snapshot';

		const persistLabel = !!this.state.snapshotId || !!this.state.error;

		// Disable the callback if we already have a snapshotId
		const callback = this.state.snapshotId ? null : this.getSnapshot;

		return (
			<div className={this.getClassNames()}>
				<ControlButton
					className="snapshot"
					iconName="Camera"
					persistLabel={persistLabel}
					label={label}
					callback={callback}
					reverseFlow
				/>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	activePet: state.activePet.active,
	activeGoodies: state.activeGoodies.active,
});

export default connect(mapStateToProps)(Snapshot);



// WEBPACK FOOTER //
// ./src/components/Extension/Snapshot/index.js